export const DEFAULT_ORIGIN = 'nav-dekoratoren';
